export default {
	state: {
		reservaSetting: {}
	},
	getters: {
		"reservaSetting": state => state.reservaSetting
	},
	mutations: {
		setReservaSetting(state, payload) {
			state.reservaSetting = payload
		}
	},
	actions: {
		atualizarEstadoReservaSetting({ commit }, payload) {
			commit('setReservaSetting', payload)
		}
	}
};